export default "__VITE_ASSET__67a315b8__"